import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { ROUTES } from '@/config/routes'
import { ShieldAlert } from 'lucide-react'

export const UnauthorizedPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <Card className="max-w-lg w-full">
        <CardHeader>
          <div className="flex items-center gap-2">
            <ShieldAlert className="h-6 w-6 text-orange-600" />
            <CardTitle className="text-2xl">Access Denied</CardTitle>
          </div>
          <CardDescription>You don't have permission to access this resource</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="rounded-md bg-orange-50 p-4 text-sm text-orange-800">
            You are not authorized to access this page or resource. This could be because:
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>You don't have the required permissions</li>
              <li>Your account access has been restricted</li>
              <li>The resource you're trying to access doesn't exist</li>
            </ul>
          </div>
          <p className="mt-4 text-sm text-muted-foreground">
            If you believe this is an error, please contact your administrator or support team.
          </p>
        </CardContent>
        <CardFooter className="flex flex-col space-y-2">
          <Button asChild className="w-full">
            <Link to={ROUTES.DASHBOARD}>
              Return to Dashboard
            </Link>
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to={ROUTES.LOGIN}>
              Log Out
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
